import TopBar from "@/components/TopBar";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

interface SiteLayoutProps {
  children: React.ReactNode;
  navVariant?: "default" | "consultation";
}

const SiteLayout = ({ children, navVariant = "default" }: SiteLayoutProps) => {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <a href="#main-content" className="sr-skip-link">
        Skip to main content
      </a>
      {navVariant === "default" ? <TopBar /> : null}
      <Navbar variant={navVariant} />
      <main id="main-content">{children}</main>
      <Footer />
    </div>
  );
};

export default SiteLayout;
